var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressOneThird = function SvgProgressOneThird(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.388 14.337A9 9 0 1 1 10.5 1v9zM10.5 0c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10",
    clipRule: "evenodd",
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_progress_one_third__clip0_2363_7168)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.75 12.888 5.162 9.3l-1.224 1.225 3.587 3.588 1.225 1.225L17.587 6.5l-1.224-1.312z",
    opacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_progress_one_third__clip0_2363_7168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.5,
    fill: "#fff",
    rx: 10
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressOneThird);
export { ForwardRef as ReactComponent };